<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="600" persistent @input="closeModal">
      <v-card class="card">
        <v-card-title class="headline accent--text pb-4">
          {{ isEdit ? 'Редактировать' : 'Добавить' }}
        </v-card-title>
        <v-card-text outlined tile class="border-top">
          <v-container>
            <v-row>
              <v-col cols="12" class="pb-0 pt-6">
                <v-text-field
                  v-model="order.orderNumber"
                  label="Номер приказа"
                  placeholder="Введите номер приказа"
                  outlined rounded dense
                  v-mask="'########'"
                  @input="$v.order.orderNumber.$touch()"
                  @blur="$v.order.orderNumber.$touch()"
                  :error-messages="errorMessages.orderNumber"
                />
              </v-col>

              <v-col cols="12" class="py-0">
                <UIDatePicker
                  label="Дата приказа"
                  v-model="order.orderDate"
                  :error-messages="errorMessages.orderDate"
                  @input="$v.order.orderDate.$touch()"
                />
              </v-col>

              <v-col cols="12" class="py-0">
                <UIDatePicker
                  label="Дата начала действия приказа"
                  v-model="order.effectiveDate"
                  :error-messages="errorMessages.effectiveDate"
                  @input="$v.order.effectiveDate.$touch()"
                />
              </v-col>

              <v-col cols="12" class="py-0">
                <v-autocomplete
                  v-model="order.paidForm"
                  :items="paidForm"
                  item-text="name"
                  label="Вид оплаты"
                  placeholder="Выберите из списка"
                  outlined rounded dense return-object
                  @input="$v.order.paidForm.$touch()"
                  @blur="$v.order.paidForm.$touch()"
                  :error-messages="errorMessages.paidForm"
                />
              </v-col>

              <v-col cols="12" class="py-0">
                <v-autocomplete
                  v-model="order.speciality"
                  :items="speciality"
                  item-text="name"
                  label="Специальность"
                  placeholder="Выберите из списка"
                  outlined rounded dense return-object
                  @input="$v.order.speciality.$touch()"
                  @blur="$v.order.speciality.$touch()"
                  :error-messages="errorMessages.speciality"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn text color="lightGrey" @click="closeModal"> {{ 'Отмена' }} </v-btn>
          <v-btn
            :loading="loading"
            :disabled="$v.$invalid"
            color="success"
            text
            @click="saveOrder"
          >
            {{ isEdit ? 'Сохранить' : 'Создать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  required,
  maxLength
} from 'vuelidate/lib/validators'
import { Order } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import {
  paidFormApi,
  specialityApi
} from "@/api"
import UIDatePicker from "@/components/ui/UIDatePicker";

export default {
  components: {UIDatePicker},
  props: {
    loading: Boolean,
    dialog: Boolean,
    selectedItem: Object
  },

  async created() {
    await this.loadCatalogs()
  },

  data: () => ({
    order: new Order(),
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menuOrderDate: false,
    menuActivityFromDate: false,
    department: [],
    paidForm: [],
    speciality: [],
  }),

  validations() {
    return {
      order: {
        orderDate: { required },
        effectiveDate: { required },
        orderNumber: { required },
        paidForm: { required },
        speciality: { required }
      }
    }
  },

  computed: {
    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.order.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.order[key])
      })

      return allErrors
    }
  },

  methods: {
    async loadCatalogs() {
      const [speciality, paidForm] = await Promise.all([
        specialityApi.getCatalog(),
        paidFormApi.getCatalog()
      ])

      this.speciality = speciality
      this.paidForm = paidForm
    },

    saveOrder() {
      this.$emit('saveOrder', this.order.getForAPI())
    },

    resetModal() {
      this.$v.$reset()
      this.order = new Order()
    },

    closeModal() {
      this.order = new Order()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(val) {
      this.order = val ? Order.buildFromAPI(val) : new Order()
    },

    dialog(val) {
      !val && this.resetModal()
    }
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.card >>> .v-label.theme--light {
  font-size: 14px;
  color: rgba(55, 71, 79, .8) !important;
}

.card >>> .v-label.v-label--active.theme--light {
  font-size: 16px;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important
}
</style>